export enum ChallengeStage {
  NotStarted = 'NotStarted',
  InitVitalsEntryStart = 'InitVitalsEntryStart',
  InitVitalsEntryFinished = 'InitVitalsEntryFinished',
  FinalVitalsEntryStart = 'FinalVitalsEntryStart',
  FinalVitalsEntryFinished = 'FinalVitalsEntryFinished',
  Finished = 'Finished',
}
